<template>
  <gl-page icon-name="gr-wallet" title="Platincoin address">
    <div v-if="load === 'success'" class="contentAddress">
      <address-details
        :address="address"
        class="contentAddress__section"
        @is-show="handleShowDetails"
      />
      <div class="contentAddress__section">
        <address-transactions :txs="txs" />
        <gl-loader-lazy ref="gl-loader-lazy" @load-more="handlerLoadingMore" />
      </div>
    </div>
    <div v-else-if="load === 'error'" class="text-gray">
      Unexpected Error!
    </div>
    <gl-loader v-else />
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import AddressDetails from '@/components/Address/AddressDetails/index'
import AddressTransactions from '@/components/Address/AddressTransactions'
import { getAddress, getBlockInfo } from '@/services/api'
import GlLoader from '@gl/GlLoader'
import GlLoaderLazy from '@gl/GlLoaderLazy'
import { loadMoreCount, updatePeriod } from '@/config'
import { blockInfo } from '@/store'

export default {
  name: 'Address',
  components: { GlLoader, GlLoaderLazy, AddressTransactions, AddressDetails, GlPage },
  data() {
    return {
      load: 'loading',
      loadMoreActiveRequest: false,
      reloadActiveRequest: false,
      address: {},
      txs: [],
      timer: null,
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'Address') {
        this.load = 'loading'
        this.loadAddress()
      }
    },
  },
  async mounted() {
    if (!blockInfo.moneybox) {
      await getBlockInfo()
    }
    await this.loadAddress()
  },
  methods: {
    async loadAddress() {
      const id = this.$route?.params?.id
      if (!id) {
        this.load = 'error'
        return
      }

      const isTest = blockInfo.moneybox.startsWith('P4s') || blockInfo.moneybox.startsWith('P4t')
      /** Lock if moneybox or testnet */
      if (!isTest && (id === blockInfo.moneybox || id.startsWith('P4s') || id.startsWith('P4t'))) {
        await this.$router.replace({ path: '/NotFound' })
        return
      }

      const { data } = await getAddress(id)
      if (data.state === 'success') {
        const address = data.data
        const txs = address.tx
        this.address = { ...address, tx: undefined }
        this.txs = txs
        this.load = 'success'
      } else {
        this.load = 'error'
      }
    },
    async reloadAddress() {
      const id = this.$route?.params?.id
      if (!id || this.load !== 'success' || this.loadMoreActiveRequest) return

      this.reloadActiveRequest = true

      const { data } = await getAddress(id)
      if (data.state === 'success') {
        if (
          this.load === 'success' &&
          this.address.address === data.data.address &&
          !this.loadMoreActiveRequest
        ) {
          this.txs = data.data.tx
          this.address = { ...data.data, tx: undefined }
          this.$refs['gl-loader-lazy'].processing()
        }
      }

      this.reloadActiveRequest = false
    },
    async handlerLoadingMore() {
      const count = await this.loadMore()
      if (!count) this.$refs['gl-loader-lazy'].completed()
    },
    async loadMore() {
      if (this.loadMoreActiveRequest) return -1

      this.loadMoreActiveRequest = true
      const page = Math.ceil(this.txs.length / loadMoreCount)

      const { data } = await getAddress(this.address.address, page)
      if (data.state === 'success') {
        const address = data.data
        const txs = address.tx
        this.txs.push(...txs)
        this.loadMoreActiveRequest = false
        return txs.length
      } else {
        this.loadMoreActiveRequest = false
        return -1
      }
    },
    handleShowDetails(value) {
      if (value) {
        // this.reloadAddress()
        this.timer = setInterval(() => {
          this.reloadAddress()
        }, updatePeriod)
      } else {
        clearInterval(this.timer)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contentAddress {
  @include grid();

  &__section {
    grid-column: 1 / -1;
    overflow: hidden;
  }
}
</style>
